import styles from './Image.module.scss'
import cn from 'classnames'
import { default as NextImage } from 'next/image'
import HTML from '@/components/HTML'

function ImageRoot({ data = {}, className, ...props }) {
  return (
    <figure
      className={cn(styles['root'], { [className]: className })}
      {...props}
    >
      <NextImage
        src={data.sourceUrl}
        alt={data.altText}
        width={data.mediaDetails.width}
        height={data.mediaDetails.height}
      />

      {data.caption && (
        <figcaption className="mt-2">
          <HTML className="text-start font-grotesk text-xs font-medium">{data.caption}</HTML>
        </figcaption>
      )}
    </figure>
  )
}

export default ImageRoot
